module.exports = __webpack_public_path__ + "img/la-textil-main-bg.55e3ca7c.jpg";